import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
import {
  Card,
  Stack,
  Paper,
  Pagination,
  Typography,
  CircularProgress,
  Grid,
  Box,
  Chip,
  Divider
} from '@mui/material';

import { useAxios } from '../../../context/AxiosHookContext';
import { UserListToolbar } from '../../../sections/@dashboard/user';
import TrainingCard from './TrainingCard';



export default function TrainingList({ type, subtype, title, onUpdate }) {
  const [filterName, setFilterName] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [trainingList, setTrainingList] = useState([]);

  const axios = useAxios();

  const getDetailedData = (row) => {
    let data = {};
    if (type === 'Recomendación') {
      if (subtype === 'Persona física') data = row.RecomendacionFisica || {};
      if (subtype === 'Institución pública') data = row.RecomendacionPublica || {};
      if (subtype === 'Agente económico') data = row.RecomendacionAgente || {};
    } else if (type === 'Capacitación') {
      if (subtype === 'Persona física') data = row.capacitacionPersona || {};
      if (subtype === 'Institución pública') data = row.capacitacionPublica || {};
      if (subtype === 'Agente económico') data = row.capacitacionAgente || {};
    }
    
    // Solo incluir documento si existe y tiene valor en la raíz del objeto row
    if (row.documento && row.documento !== null && row.documento !== undefined && row.documento !== '') {
      data.documento = row.documento;
    }
    
    return data;
  };

  const getTrainings = useCallback(async () => {
    try {
      setTrainingList([]);
      setLoading(true);
      
      const params = new URLSearchParams({
        page: page.toString(),
        limit: '10',
        ...(filterName && { filterName })
      });

      const { data } = await axios.get(`/trainings/by-type-subtype?type_filter=${encodeURIComponent(type)}&subtype_filter=${encodeURIComponent(subtype)}&${params}`);
      
      setTrainingList(data.data.list);
      setTotalPages(data.data.total_pages);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, type, subtype, page, filterName]);

  useEffect(() => {
    getTrainings();
  }, [getTrainings]);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleFilterByName = (event) => {
    setPage(1);
    setFilterName(event.target.value);
  };

  const getSolicitanteName = (row) => {
    if (type === 'Recomendación') {
      if (subtype === 'Persona física') return row.RecomendacionFisica?.nombre || 'N/A';
      if (subtype === 'Institución pública') return row.RecomendacionPublica?.institucion || 'N/A';
      if (subtype === 'Agente económico') return row.RecomendacionAgente?.empresa || 'N/A';
    } else if (type === 'Capacitación') {
      if (subtype === 'Persona física') return row.capacitacionPersona?.nombre || 'N/A';
      if (subtype === 'Institución pública') return row.capacitacionPublica?.institucion || 'N/A';
      if (subtype === 'Agente económico') return row.capacitacionAgente?.empresa || 'N/A';
    }
    return 'N/A';
  };

  return (
    <>
      <Helmet>
        <title>{title} | {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>

      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>
      </Stack>

      <Box>
        <Card sx={{ mb: 2 }}>
          <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />
        </Card>

        {loading && (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress size={40} />
          </Box>
        )}

        {!loading && trainingList.length === 0 && (
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h6" paragraph>
              Sin resultados
            </Typography>
            <Typography variant="body2">
              No se encontraron resultados. Intente con otra búsqueda.
            </Typography>
          </Paper>
        )}

        <Stack spacing={2}>
          {trainingList?.map((row) => (
            <TrainingCard 
              key={row._id}
              row={row}
              type={type}
              subtype={subtype}
              getSolicitanteName={getSolicitanteName}
              getDetailedData={getDetailedData}
              onUpdate={() => {
                getTrainings();
                if (onUpdate) onUpdate();
              }}
            />
          ))}
        </Stack>

        {totalPages > 1 && (
          <Card sx={{ mt: 4, p: 2 }}>
            <Stack 
              direction={{ xs: 'column', sm: 'row' }} 
              justifyContent="space-between" 
              alignItems="center"
              spacing={2}
            >
              <Typography variant="body2" color="text.secondary">
                Página {page} de {totalPages}
              </Typography>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChangePage}
                color="primary"
                size="large"
                showFirstButton
                showLastButton
                sx={{
                  '& .MuiPaginationItem-root': {
                    borderRadius: 2,
                    '&:hover': {
                      backgroundColor: 'primary.light',
                      color: 'white'
                    }
                  }
                }}
              />
            </Stack>
          </Card>
        )}
      </Box>
    </>
  );
}